import $ from "jquery";

class NewsletterForm {
    constructor(el) {
        this.$el = $(el);

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.$gdprIcon = this.$el.find('.newsletter-form__gdpr-icon');
        this.$gdprMention = this.$el.find('.newsletter-form__gdpr-mention');
        this.$gdprMentionCloseButton = this.$el.find('.newsletter-form__gdpr-mention-close-button');

        this._bindEvents();
    }

    _bindEvents() {
        this.openMentionFn = this._openMention.bind(this);
        this.closeMentionFn = this._closeMention.bind(this);

        this.$gdprIcon.on('click', this.openMentionFn);
        this.$gdprMentionCloseButton.on('click', this.closeMentionFn);
    }

    _openMention() {
        this.$gdprMention.addClass('newsletter-form__gdpr-mention--visible');
    }

    _closeMention() {
        this.$gdprMention.removeClass('newsletter-form__gdpr-mention--visible');
    }
}

export default NewsletterForm;
